import React, {useCallback, useEffect, useState} from 'react';

import {DateRangeInput} from 'src/components/input';
import {RequiredMark} from 'src/components/required-mark/required-mark';
import {useDateValidation} from 'src/hooks/useDateValidation';
import {IntegrationPartner as IntegrationPartners} from 'src/openapi/admin/models/IntegrationPartner';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Group, Item} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import {INPUT_WIDTH, INTEGRATION_PARTNERS} from '../constants';


import type {EditIntegrationContract} from '../typedef';
import type {IntegrationPartner} from 'src/openapi/admin/models/IntegrationPartner';


type Props = {
    disabled: boolean,
    onEditData: (data: EditIntegrationContract) => void,
    onHasInvalidRange?: (value: boolean) => void,
};

export const IntegrationContractDetails = (props: Props) => {
    const [integrationPartner, setIntegrationPartner] = useState<IntegrationPartner>(IntegrationPartners.SANDBOX);
    const [endDate, setEndDate] = useState('');
    const [startDate, setStartDate] = useState('');

    const {disabled, onEditData, onHasInvalidRange} = props;
    const {hasInvalidRange} = useDateValidation(startDate, endDate, setStartDate);

    useEffect(() => {
        onHasInvalidRange?.(hasInvalidRange);
    }, [hasInvalidRange, onHasInvalidRange]);

    useEffect(() => {
        onEditData({endDate, startDate, integrationPartner});
    }, [startDate, endDate, integrationPartner]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeIntegrationPartner = useCallback((value: IntegrationPartner) => {
        setIntegrationPartner(value);
    }, []);

    return (
        <Group gap="xl" alignItems="start" justify="space-between">
            <Item>
                <Label><RequiredMark label="Contract Term"/></Label>
                <Group direction="v" gap="s">
                    <DateRangeInput
                        id="add-contract-start-date"
                        label={<>Starts</>}
                        width={INPUT_WIDTH}
                        clearable={true}
                        startDate={startDate}
                        endDate={endDate}
                        selectRangeType="start"
                        onChange={setStartDate}
                    />
                    <DateRangeInput
                        id="add-contract-end-date"
                        label={<>Ends&nbsp;&nbsp;</>}
                        width={INPUT_WIDTH}
                        clearable={true}
                        startDate={startDate}
                        endDate={endDate}
                        selectRangeType="end"
                        onChange={setEndDate}
                    />
                </Group>
            </Item>
            <Item>
                <Label>Integration Partner</Label>
                <ComboBox
                    {...{
                        disabled,
                        width: INPUT_WIDTH,
                        value: integrationPartner,
                        onChange: onChangeIntegrationPartner,
                    }}>
                    {Object.keys(INTEGRATION_PARTNERS).map(key => (
                        <ComboboxItem
                            key={key}
                            caption={INTEGRATION_PARTNERS[key as IntegrationPartner]}
                            value={key}
                        />
                    ))}
                </ComboBox>
            </Item>
        </Group>
    );
};
